import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'rule-destination-condition',
  templateUrl: './rule-destination-condition.component.html',
  styleUrls: ['./rule-destination-condition.component.scss']
})
export class RuleDestinationConditionComponent {

  @Input() item: any;

  constructor() {
  }

  isUserGroupsExists(value): boolean {
    return value && value.userGroups && value.userGroups.length > 0;
  }

  isCustomersExists(value): boolean {
    return value && value.destCustomers && value.destCustomers.length > 0;
  }

  useAllCustomers(value): boolean {
    return value && value.allDestCustomers;
  }

  isRRAttributesExists(value, parameter): boolean {
    switch (parameter) {
      case 'general'     :
        return value && value.rrAttrs;
      case 'host'        :
        return value.rrAttrs.attributes.host && value.rrAttrs.attributes.host.length > 0;
      case 'prefix'      :
        return value.rrAttrs.attributes.prefix && value.rrAttrs.attributes.prefix.length > 0;
      case 'prefixGroups':
        return value.rrAttrs.attributeGroups && value.rrAttrs.attributeGroups.length > 0;
    }
  }

}
